import { Action, createReducer, on } from '@ngrx/store';
import { ReservationErrorTypeKey } from 'src/app/models/reservation-errors';
import * as actions from './actions';
import { SchedulerState } from './state';

export const initialSchedulerState: SchedulerState = {
  errors: [
    {
      kind: ReservationErrorTypeKey.NotInitialized,
    },
  ],
  printView: false,
  showConsolidatedAppointments: true,
};

const schedulerReducers = createReducer(
  initialSchedulerState,
  on(actions.SetSchedulerErrors, (state, { errors }) => ({ ...state, errors })),
  on(actions.SetSchedulerPrintView, (state, { printView }) => ({ ...state, printView })),
  on(actions.SetShowConsolidatedAppointments, (state, { showConsolidatedAppointments }) => ({
    ...state,
    showConsolidatedAppointments,
  })),
);

export function reducers(
  state: SchedulerState | undefined,
  action: Action,
): Partial<SchedulerState> {
  return schedulerReducers(state, action);
}
